import { fetchJson } from '@frontend/store/fetch';

interface ICostInfoAndConsent {
    price?: number;
    showCostInfoAndConsentModal: boolean;
    vatRate?: number;
}

export async function getCostInfoAndConsent(
    serviceId: string,
    requestId?: string | null
): Promise<ICostInfoAndConsent> {
    let url = `/api/services/${serviceId}/costInfo`;

    if (requestId) {
        url = `${url}?requestId=${requestId}`;
    }

    const result = (await fetchJson(url, 'GET')).json;

    return {
        showCostInfoAndConsentModal: result.shouldShowCostInfo,
        price: result.priceWithoutVat,
        vatRate: result.vatRate,
    };
}
